import React, { useEffect, useState } from 'react';
import './FilterOption.style.css';
import { Checkbox } from 'antd';
import { DownOutlined, UpOutlined } from '@ant-design/icons';

const FilterOption = ({
  title = '',
  options = [],
  multiple = false,
  style = {},
  titleStyle = {},
  optionStyle = {},
  maxHeight = 410,
  onChange,
  value = [],
  collapsible = false,
  icon = (open) => (open ? <UpOutlined /> : <DownOutlined />),
}) => {
  /* ===== Route ===== */
  /* ===== Props ===== */
  /* ===== State ===== */
  const [checkedItems, setCheckedItems] = useState(value);
  const [isOpen, setIsOpen] = useState(false);

  const [isChange, setIsChange] = useState(false);

  /* ===== Hooks ===== */
  /* ===== Function ===== */
  /**
   * 체크박스 핸들러
   * --
   */
  const handleCheckedItem = React.useCallback((t, c) => {
    setCheckedItems((prev) => {
      // 체크 해제하는 경우
      if (!c) {
        return prev.filter((item) => item !== t);
      }

      // 체크하는 경우
      if (multiple) {
        // 이미 추가된 경우 중복 방지
        if (!prev.includes(t)) {
          return [...prev, t];
        }
        return prev;
      }

      // 멀티 체크가 불가능한 경우
      return [t];
    });

    setIsChange(true);
    // eslint-disable-next-line
  }, []);

  /**
   * Collapse 토글 버튼
   * --
   */
  const handleToggleCollapse = () => {
    setIsOpen(!isOpen);
  };

  /* ===== Variable ===== */
  /* ===== Hooks ===== */
  useEffect(() => {
    if (onChange && isChange) {
      onChange(checkedItems); // 새로운 배열을 생성하여 불변성을 보장
      setIsChange(false);
    }
    // eslint-disable-next-line
  }, [isChange, onChange]);

  /* ===== Render ===== */
  return (
    <div className="filter_layout" style={{ ...style }}>
      <div
        className="filter_title_wrap"
        onClick={collapsible ? handleToggleCollapse : undefined}
      >
        <div className="filter_title">
          <h4 style={{ ...titleStyle }}>{title}</h4>
          {collapsible ? icon(isOpen) : null}
        </div>
      </div>
      <ul
        className="filter_options"
        style={{
          // maxHeight: maxHeight,
          maxHeight: collapsible ? (isOpen ? maxHeight : 0) : maxHeight,
        }}
      >
        {options.map((_item, _index) => (
          <li key={`option_${_index}_${_item.value}`}>
            <Checkbox
              key={`checkbox_${_index}`}
              checked={value.some((check) => check === _item.value)}
              style={{ ...optionStyle }}
              onChange={(e) => handleCheckedItem(_item.value, e.target.checked)}
            >
              {_item.label}
            </Checkbox>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FilterOption;
